import React from 'react';

const EnrichIcon = ({ color = '#7f38e9', width = 19, height = 20, ...rest }, ref) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
      ref={ref}>
      <path
        d="M4.15625 5.25C4.48417 5.25 4.75 4.98417 4.75 4.65625C4.75 4.32833 4.48417 4.0625 4.15625 4.0625C3.82833 4.0625 3.5625 4.32833 3.5625 4.65625C3.5625 4.98417 3.82833 5.25 4.15625 5.25Z"
        fill={color}
      />
      <path
        d="M4.15625 10C4.48417 10 4.75 9.73417 4.75 9.40625C4.75 9.07833 4.48417 8.8125 4.15625 8.8125C3.82833 8.8125 3.5625 9.07833 3.5625 9.40625C3.5625 9.73417 3.82833 10 4.15625 10Z"
        fill={color}
      />
      <path
        d="M4.15625 14.75C4.48417 14.75 4.75 14.4842 4.75 14.1562C4.75 13.8283 4.48417 13.5625 4.15625 13.5625C3.82833 13.5625 3.5625 13.8283 3.5625 14.1562C3.5625 14.4842 3.82833 14.75 4.15625 14.75Z"
        fill={color}
      />
      <path
        d="M7.125 15.9375H2.375V12.375H7.125V11.1875H2.375V7.625H13.0625V2.875C13.0625 2.56006 12.9374 2.25801 12.7147 2.03531C12.492 1.81261 12.1899 1.6875 11.875 1.6875H2.375C2.06006 1.6875 1.75801 1.81261 1.53531 2.03531C1.31261 2.25801 1.1875 2.56006 1.1875 2.875V15.9375C1.1875 16.2524 1.31261 16.5545 1.53531 16.7772C1.75801 16.9999 2.06006 17.125 2.375 17.125H7.125V15.9375ZM2.375 2.875H11.875V6.4375H2.375V2.875Z"
        fill={color}
      />
      <path
        d="M16.625 10.5939V12.0266C16.2521 11.4031 15.7222 10.8883 15.0881 10.5336C14.454 10.1789 13.738 9.99666 13.0115 10.0052C12.285 10.0137 11.5734 10.2126 10.9478 10.582C10.3222 10.9515 9.80449 11.4786 9.44626 12.1107C9.08804 12.7428 8.90186 13.4578 8.90633 14.1843C8.91079 14.9108 9.10574 15.6235 9.47171 16.2511C9.83768 16.8788 10.3619 17.3994 10.992 17.7612C11.622 18.1229 12.336 18.3131 13.0625 18.3126V17.1251C12.5271 17.1258 12.0015 16.9817 11.5413 16.7081C11.0811 16.4345 10.7035 16.0415 10.4484 15.5707C10.1934 15.1 10.0703 14.569 10.0924 14.0341C10.1145 13.4991 10.2808 12.9801 10.5737 12.532C10.8667 12.0838 11.2754 11.7233 11.7565 11.4884C12.2377 11.2536 12.7734 11.1533 13.3069 11.198C13.8404 11.2428 14.3519 11.431 14.7872 11.7428C15.2225 12.0545 15.5654 12.4782 15.7795 12.9689H14.25V14.1564H17.8125V10.5939H16.625Z"
        fill={color}
      />
    </svg>
  );
};

export default React.forwardRef(EnrichIcon);
